// hooks/useMFAStatus.js
import { useEffect, useState } from "react";
import { supabase } from "lib/supabase";

export const useMFAStatus = () => {
  const [aalLevel, setAalLevel] = useState(null); // "aal1" | "aal2"
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
      setAalLevel(error ? null : data?.currentLevel);
      setLoading(false);
    };
    check();
  }, []);

  return { aalLevel, loading, isMFAVerified: aalLevel === "aal2" };
};